const initialState = {
  loading: false,
  data: null,
  error: null,
};

export const bookingTrendsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_BOOKING_TRENDS_REQUEST":
      return { ...state, loading: true };
    case "GET_BOOKING_TRENDS_SUCCESS":
      return { loading: false, data: action.payload, error: null };
    case "GET_BOOKING_TRENDS_FAILURE":
      return { loading: false, data: null, error: action.payload };
    default:
      return state;
  }
};

export const installmentReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_INSTALLMENT_RECOVERY_REQUEST":
      return { ...state, loading: true };
    case "GET_INSTALLMENT_RECOVERY_SUCCESS":
      return { loading: false, data: action.payload, error: null };
    case "GET_INSTALLMENT_RECOVERY_FAILURE":
      return { loading: false, data: null, error: action.payload };
    default:
      return state;
  }
};

export const overdueInstallmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_OVERDUE_INSTALLMENTS_REQUEST":
      return { ...state, loading: true };
    case "GET_OVERDUE_INSTALLMENTS_SUCCESS":
      return { loading: false, data: action.payload, error: null };
    case "GET_OVERDUE_INSTALLMENTS_FAILURE":
      return { loading: false, data: null, error: action.payload };
    default:
      return state;
  }
};
